import { CalendarService } from '@b2b/common/services/calendar';
import { UserPreferencesService } from '@b2b/common/services/userPreferences/types';
import { input, TODO } from '@b2b/types/core';
import angular, { IOnChangesObject } from 'angular';

class FormatDateController {
  static $inject = ['$element', 'CalendarService', 'UserPreferencesService', 'HelpersService'];

  date = input<Date | string>();
  fallback = input<string>();
  format = input<string>();

  formattedDate = '';

  constructor(
    private $element: JQuery,
    private calendarService: CalendarService,
    private userPreferencesService: UserPreferencesService,
    private helpersService: TODO,
  ) {}

  $onInit() {
    this.$element.addClass('acme-format-date');
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.date || changes.format) {
      this.updateFormattedDate();
    }
  }

  private updateFormattedDate() {
    if (!this.date) {
      this.formattedDate = this.fallback ?? '';
      return;
    }

    // Get the format from user preferences or use the provided format
    const dateFormat = this.getResolvedFormat();

    // Parse the date if it's a string, otherwise use it directly
    const parsedDate = typeof this.date === 'string' ? this.calendarService.parseDate(this.date) : this.date;

    this.formattedDate = this.calendarService.toFormat(parsedDate, dateFormat);
  }

  private getResolvedFormat(): string {
    if (!this.format) {
      // Default to standardDate format
      return this.userPreferencesService.getDateFormat('standardDate', 'dateFormat');
    }

    // Check if the format is a known format key in HelpersService.dateFormats
    const helperFormat = this.helpersService.dateFormats[this.format];

    if (helperFormat) {
      // Use user preferences for known format types
      return this.userPreferencesService.getDateFormat(this.format, 'dateFormat');
    }

    // Otherwise, use the format string directly
    return this.format;
  }
}

export const FormatDateComponentModule = angular
  .module('acme.common.component.format-date', [
    'acme.common.service.calendar',
    'acme.common.service.userPreferences',
    'acme.common.service.helpers',
  ])
  .component('acmeFormatDate', {
    templateUrl: 'common/components/format-date/format-date.component.tpl.html',
    controller: FormatDateController,
    controllerAs: '$ctrl',
    bindings: {
      date: '<',
      format: '<',
      fallback: '<',
    },
  }).name;
